module.exports = __webpack_public_path__ + "img/bozo_skoko.365f0b7f.png";